import { render } from "./JobSpecDownload.vue?vue&type=template&id=18de38e2&scoped=true"
import script from "./JobSpecDownload.vue?vue&type=script&lang=js"
export * from "./JobSpecDownload.vue?vue&type=script&lang=js"

import "./JobSpecDownload.vue?vue&type=style&index=0&id=18de38e2&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\52618\\Documentos\\TheGoodMark\\Sistemas\\RHTGM\\orangehrm-5.9\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18de38e2"]])

export default __exports__